import { useContext } from "react"
import { Avatar, Box, List, ListItem, ListItemButton, ListItemText, Stack } from "@mui/material"

import { ThemeContext } from "../../context/theme/context"
import logo from '../../assets/picture (1).jpg'

const Navbar = () => {
    const { state } = useContext(ThemeContext)

    return (
        <Box sx={{
            position: "relative",
            width: "100%",
        }}>
            <Stack
                width="100%"
                padding="2% 4%"
                direction="row"
                justifyContent="space-between"
                position='fixed'
                top={0}
                left={0}
                zIndex={9}
                color={state.color.primary}>
                <Box>
                    <Avatar
                        alt="Industrial Designer"
                        src={logo}
                        loading='lazy'
                    />
                </Box>
                <List>{["Home", "About", "Contact"].map((item, index) => {
                    return (
                        <ListItem disablePadding key={index}>
                            <ListItemButton
                                fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                                href={`#${item}`}
                                sx={{
                                    fontSize: { xs: 14, md: 18 },
                                    fontWeight: 900,
                                    textAlign: 'center',
                                    textTransform: 'uppercase',
                                    '&:hover': {
                                        color: state.color.primary
                                    }
                                }}>
                                <ListItemText primary={item} />
                            </ListItemButton>
                        </ListItem>
                    )
                })}
                </List>
            </Stack>
        </Box >
    )
}

export default Navbar